// extracted by mini-css-extract-plugin
export default {"profile-selection-form":"ProfileSelectionForm_profile-selection-form__YQXFH"};